export default __webpack_public_path__ + "static/media/pinkTheme-girl.154b10ae.svg";